import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../../Vas';
import '../../../css/CustomerPaymentData.css';
import CustomerPaymentDetails from './CustomerPaymentDetails';
import { Icon,PagingTable } from 'component-lib';
import { RoleConfiguration,DateTimeHelper } from 'utils-lib';
import { RequestAjaxClass, PaymentsModel } from 'models-lib';

class CustomerPaymentData extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.Payments = [];
        this.state.CurrentView = "CustomerPaymentData";
        this.CustomerId = props.id;
        this.state.Ref=this.props.me;
        this.state.Limit = 10;
        this.state.Start = 0;
        this.GetRequest = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.PaymentsModel = new PaymentsModel([this]);
    }

    componentWillMount(){
        this.GetRequest.setApiUrl(Vas.ApiUrl);
        this.GetRequest.setApiKey(Vas.ApiKey);
        this.GetRequest.setAuth(true);
        this.GetRequest.setErrorHandler(()=>{
            $("#LoadingIcon").removeClass().addClass('hide');
        });
        this.PaymentsModel.SetRequest(this.GetRequest);
    }

    Update(observer){
        let me = this;
        this.setState({},()=>{
            if(observer === "Payment"){
                let payments = [];
                if(this.PaymentsModel.Count > 0){
                    this.PaymentsModel.Payments.forEach(function(value) {
                        if (value.PaymentMethodValue === 4){
                            let payment = {};
                            payment.Id = value.Id;
                            payment.BankName = value.BankName;
                            payment.AccountOwner = value.AccountOwner;
                            payment.Iban= value.Iban.substr(value.Iban.length -6,6);
                            payment.BIC = value.Bic;
                            let from = "";
                            let to = "";
                            if (value.ValidFrom !== null && value.ValidFrom !== "")
                                {from = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(value.ValidFrom,true,localStorage.getItem('vas_language')));}
                            if (value.ValidTo !== null && value.ValidTo !== "")
                                {to = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(value.ValidTo,true,localStorage.getItem('vas_language')));}
                            payment.ValidFrom=from;
                            payment.ValidTo=to;
    
                            let defaultPay='';
                            if (value.IsDefaultPaymentMethod === true){
                                defaultPay=(<Icon
                                  Name={"Done"}
                                  Size={24}
                                  Color={"green"}
                                  Align={"left"} />);
                            }
    
                            payment.IsDefaultPaymentMethod=defaultPay;
                            payments.push(payment);
                        }
                    });
                }
                if (me.refs.table){
                    me.refs.table.setState({ Data: payments, Count: payments.length, Limit: this.PaymentsModel.Limit, Start: this.PaymentsModel.Start, End: this.PaymentsModel.Start+payments.length });
                }
                $("#LoadingIcon").removeClass().addClass('hide');
                
            }
        });
    }

    createPayment(){
        Vas.GetView('CreatePayment', {CustomerId : this.CustomerId, NewContract: false}, true);
    }

    LoadPaymentDetails(id,Payments)
    {
        ReactDOM.unmountComponentAtNode(document.getElementById('paymentDetails'));
        ReactDOM.render(<CustomerPaymentDetails
          Id={id}
          data={Payments}
          CustomerId={this.CustomerId}
          reference={this}
          table={this.refs.table} />, document.getElementById('paymentDetails'));
    }

    load(sendData){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        this.PaymentsModel.GetPaymentsByCustomerId(this.CustomerId,sendData);
    }

    loadPayment(id){
        let me = this;
        let payments=me.refs.table.state.Data;
        let payment=[];
        for (let i=0;i<payments.length;i++){
            if (payments[i].Id === id){
                payment.push(payments[i]);
            }
        }
        me.LoadPaymentDetails(id,payment);
    }

    render()
    {  
        let rights = RoleConfiguration.getRoleConfig();
        let role = localStorage.getItem("vas_role");
        
        let right = '';
        if (role === "1"){
            if (rights[1]){
                right =  rights[1];
            }
        }
        if (role === "3"){
            if (rights[0]){
                right = rights[0];
            }
        }

        return (<div ><table >
            
          <tbody>
            <tr>
              <td>
                <PagingTable
                ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
                  ref="table"
                  TableReference={this}
                  DataBaseTable={"B2Zahlweise"}
                  Selectable={false} 
                  Limit={this.state.Limit}
                  Start={this.state.Start}
                  End={this.state.End}
                  Count={this.state.Count} 
                  Columns={[Vas.Resources.Labels["NameOfBank"],Vas.Resources.Labels["Depositor"],Vas.Resources.Labels["Iban"],
                            Vas.Resources.Labels["PFrom"],Vas.Resources.Labels["PTo"],Vas.Resources.Labels["Standard"]]}
                  Keys={["BankName","AccountOwner","Iban","ValidFrom","ValidTo","IsDefaultPaymentMethod"]} 
                  Data={this.state.Data}
                  Add={true}
                  AddClick={()=>{this.createPayment();}}
                  Search={false} 
                  Border={false}
                  Right={right}
                  LabelPage={Vas.Resources.Labels["Page"]}
                  LabelOf={Vas.Resources.Labels["Of"]}
                  LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
                  AppURL={Vas.ApplicationUrl}
                  ApiURL={Vas.ApiUrl}
                  ApiKey={Vas.ApiKey}
                  CWidth={[120,120,80,100,100,50]}
                  AddString={Vas.Resources.Labels["Add"]}
                  NewApi={true}
                  RowOnClick={(id)=>{this.loadPayment(id);}}
                    />
              </td>
            </tr>
                
          </tbody>
            
        </table><div
          className={"paymentDetails"}
          id={"paymentDetails"} >{Vas.Resources.Labels["NoPayments"]}</div></div>
        );
    }
}
export default CustomerPaymentData;
